export default "<jaspero-confirmations></jaspero-confirmations>\n<router-outlet></router-outlet>\n"